import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import {ReactComponent as TickCircle} from '../../../../assets/images/tick-circle.svg';

const OptionItem = ({label, svgImage, value, withCheckBox = true, inputName, onSelect, isChecked = false}) => {

    const handleOptionSelect = (e) => {
        // const {checked} = e.target;
        const {value} = e.target;
        // console.log({checked});
        // console.log({value});
        if (onSelect) {
            onSelect(+value);
        }
    };

    const checkBoxUI = withCheckBox && isChecked &&  <div className='opt-cb-wrapper'><TickCircle /></div>;
    return (
        <div className='option-item-container'>
            <label className="opt-img-wrapper">
                <input type="radio" name={inputName} value={value} onChange={handleOptionSelect} checked={isChecked} />
                {checkBoxUI}
                {svgImage}
            </label>
            <Typography variant="subtitle2">{label}</Typography>
        </div>
    );
};

export default OptionItem;

OptionItem.propTypes = {
    label: PropTypes.string.isRequired,
    inputName: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    svgImage: PropTypes.node.isRequired,
    withCheckBox: PropTypes.bool,
    isChecked: PropTypes.bool,
    onSelect: PropTypes.func,
};